import React from 'react';
import { FormControlLabel, Checkbox } from '@mui/material';

interface CheckboxOption {
  name: string;
  value: boolean;
  label: string;
}

interface CheckboxGroupProps {
  checkboxes: CheckboxOption[];
  onChange: (name: string, checked: boolean) => void;
}

const CheckboxGroup: React.FC<CheckboxGroupProps> = ({ checkboxes, onChange }) => {
  return (
    <>
      {checkboxes.map(({ name, value, label }) => (
        <FormControlLabel
          key={name}
          control={<Checkbox name={name} checked={value} onChange={(e) => onChange(name, e.target.checked)} />}
          label={label}
        />
      ))}
    </>
  );
};

export default CheckboxGroup;
